module.exports = __webpack_public_path__ + "static/media/customeronboarding.da3e746d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Help/assets/customeronboarding.png
// module id = 1863
// module chunks = 193